const name = (state) => state.name;

const activeNoteCollapsePanels = (context) => {
  if (localStorage.getItem("customer-dashboard-note-active-collapse-panels") !== null) {
    return JSON.parse(localStorage.getItem("customer-dashboard-note-active-collapse-panels"));
  }
  return context.activeNoteCollapsePanels;
};

export default {
  name,
  activeNoteCollapsePanels,
};
